module.exports = __webpack_public_path__ + "static/media/garden.10.fe1cd18c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/standard-garden/images/garden.10.jpg
// module id = 669
// module chunks = 0